const RESOURCE_GRID_PREVIEW_CONTENT = {
  height: 240,
  width: 260
};
const COMMENT_SECTION_HEIGHT = 33;
const TITLE_SECTION_HEIGHT = 34;
const TAGS_SECTION_HEIGHT = 19;
const DESKTOP_CARD_HEIGHT = 360;
const DESKTOP_CARD_WIDTH = 260;
const RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS = {
  width: 168,
  height: 200
};

export { COMMENT_SECTION_HEIGHT, DESKTOP_CARD_HEIGHT, DESKTOP_CARD_WIDTH, RESOURCE_GRID_PREVIEW_CONTENT, RESOURCE_PREVIEW_GRID_COMPACT_CARD_DIMENSIONS, TAGS_SECTION_HEIGHT, TITLE_SECTION_HEIGHT };
//# sourceMappingURL=resourcePreviewConstants.js.map
